export * from "-!../../../node_modules/babel-loader/lib/index.js!../../../node_modules/vue-loader/lib/loaders/templateLoader.js??ref--2!../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./DashboardSales.vue?vue&type=template&id=1a83f66e&scoped=true&"


//////////////////
// WEBPACK FOOTER
// ./src/views/dashboard/DashboardSales.vue?vue&type=template&id=1a83f66e&scoped=true&
// module id = 971
// module chunks = 0